export default __webpack_public_path__ + "static/media/ps_logo.674847b7.png";